import type { Lock, NetworkStatus } from '@sunucupark/client-core';
import { RealtimeBroadcast } from './broadcast';
import { FetchEventStream } from './event-stream';
import { FetchTransport } from './http-transport';
import { BrowserNetworkStatus } from './network-status';
import { MemorySessionStore } from './session-store';
import {
  BrowserClipboard,
  BrowserExternalLink,
  BrowserNotifications,
  TitleAndFaviconBadge,
} from './ui-ports';
import { WebLock } from './web-lock';

export { RealtimeBroadcast } from './broadcast';
export { FetchEventStream } from './event-stream';
export { FetchTransport } from './http-transport';
export { BrowserNetworkStatus } from './network-status';
export { MemorySessionStore } from './session-store';
export {
  BrowserClipboard,
  BrowserExternalLink,
  BrowserNotifications,
  TitleAndFaviconBadge,
} from './ui-ports';
export { WebLock } from './web-lock';

/** Everything the browser provides, wired once for the composition root. */
export interface WebPlatform {
  transport: FetchTransport;
  eventStream: FetchEventStream;
  broadcast: RealtimeBroadcast;
  sessionStore: MemorySessionStore;
  lock: Lock;
  network: NetworkStatus;
  ports: {
    badge: TitleAndFaviconBadge;
    clipboard: BrowserClipboard;
    links: BrowserExternalLink;
    notifications: BrowserNotifications;
  };
}

export function createWebPlatform(options: { title: string; iconUrl: string; badgeColor: string }): WebPlatform {
  return {
    transport: new FetchTransport(),
    eventStream: new FetchEventStream(),
    broadcast: new RealtimeBroadcast(),
    sessionStore: new MemorySessionStore(),
    lock: new WebLock(),
    network: new BrowserNetworkStatus(),
    ports: {
      badge: new TitleAndFaviconBadge(options.title, options.iconUrl, options.badgeColor),
      clipboard: new BrowserClipboard(),
      links: new BrowserExternalLink(),
      notifications: new BrowserNotifications(),
    },
  };
}
